import React from "react";
import PageWrapper from "../PageWrapper";
import ProgressSpinnerPR from "../PrimeReact/ProgressSpinnerPR";

export default function LoadingPage() {
  return (
    <PageWrapper>
      <ProgressSpinnerPR />
    </PageWrapper>
  );
}
